import { Suspense } from 'react';
import Header from '../components/Header';
import LeadConfirmation from './LeadConfirmation';
import { LeadProgram } from '../constants';
import LeadFooter from '../components/LeadFooter';

export default function DtcLeadConfirmationDev({
  isMedicaid,
  program,
  leadInfo,
}: {
  isMedicaid: boolean;
  program: LeadProgram;
  leadInfo: {
    email: string;
    first_name: string;
    last_name: string;
    phone_number: string;
  };
}) {
  return (
    <Suspense>
      <Header program={program} />
      <LeadConfirmation
        isDtc={true}
        program={program}
        isMedicaid={isMedicaid}
        handleGoBack={() => {}}
        leadInfo={leadInfo}
      />
      <LeadFooter isDtc={false} program={program} />
    </Suspense>
  );
}
